import React from 'react'

const CourseDetailsTop = () => {
  return (
      <section className="bg-white py-12  sm:px-6">
        <div className="max-w-6xl mx-auto">

         <p className="text-gray-700 text-lg mb-6 font-semibold ">
           This course is not your typical pre-recorded tutorial. 
           It’s a live-support + hands-on project-driven course designed to help you 
           master Stripe payments and build real-world, production-ready applications 
          and SDKs. Whether you’re a backend developer, freelancer, or aspiring fintech 
          engineer, this course teaches you the complete flow — from SDK architecture to front-end API integration 
          — with real project resources, guidance, and personal support.
          </p>

        <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
          What You’ll Get
        </h3>
        <h5 className="text-1xl font-semibold text-gray-900 mt-8 mb-4">Full Project Resource Access Upon Enrollment</h5>
        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li><span className='font-bold'> A fully developed Stripe SDK </span> — includes all major features like Payments, Payouts, Connect, Webhooks, Refunds, and Identity.</li>
          <li><span className='font-bold'>Express.js API backend </span>for handling customer, employee, and admin requests.</li>
          <li><span className='font-bold'>Postman Collection</span> with ready-to-test API requests for every business functionality.</li>
          <li><span className='font-bold'>Real business workflows covered:</span> Add Card, Add Bank, Payouts, Subscriptions, Refunds, etc.</li>
        </ul>

        <h3 className="text-2xl font-semibold text-gray-900  mt-8 mb-4">
          Course Structure & Teaching Method
        </h3>
        <p className="text-1xl font-semibold text-gray-900  mt-8 mb-4">Every topic is taught in 3 focused layers to ensure true understanding:</p>

        <p className="text-1xl font-semibold text-gray-900  mt-8 mb-4">
          1. Explain With Real-World Flow Diagram
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 ">
          <li>Understand the end-to-end flow from front-end → SDK → API → Stripe.</li>
          <li>Visual breakdown of how each request moves through your system.</li>
        </ul>

        <p className="text-1xl font-semibold text-gray-900  mt-8 mb-4">
          2. Live API Testing with Postman
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 ">
          <li>Learn how to test each business functionality using Postman.</li>
          <li>Detailed explanation of:</li>
          <ul>
            <li>Headers (Authorization, Content-Type, etc.)</li>
            <li>Request Body (what parameters go into the call)</li>
            <li>HTTP Method and expected Responses</li>
          </ul>
        </ul>

        <p className="text-1xl font-semibold text-gray-900  mt-8 mb-4">
          3. Hands-On Assignment
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 ">
          <li>Build the front-end logic to connect the API for that business functionality.</li>
          <li>Work on small, manageable UI challenges to reinforce what you've learned.</li>
          <li>Example: After learning how to add a bank account, students must implement the front-end logic to call the API and handle responses.</li>
        </ul>

        <p className="text-1xl font-semibold text-gray-900  mt-8 mb-4">
          4. Live Support
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 ">
          <li>Direct help on implementing each topic.</li>
          <li>Code reviews, debugging help, and feedback on assignments.</li>
          <li>Live sessions (optional based on schedule/need) to resolve doubts and explain tricky logic.</li>
        </ul>

  

          {/* <h3 className="text-2xl font-semibold text-gray-900  mt-8 mb-4">
            What You'll Learn
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700 ">
            <li>Checkout payment</li>
            <li>Manage and secure card payments</li>
            <li>Manage and direct bank transfers</li>
            <li>Managing connected accounts</li>
            <li>Handling payouts, refunds, and payment flows</li>
            <li>Identity and subscriptions</li>
          </ul> */}
        
        <p className='mt-5'>You'll work hands-on with below core technology, creating a production-grade payment architecture for modern SaaS platforms or service marketplaces.</p>
          
          <h3 className="text-2xl font-semibold text-gray-900  mt-10 mb-4">
            Core Technologies
          </h3>
        
          <ul className="list-disc pl-6 space-y-2 text-gray-700 ">
            <li>Node.js</li>
            <li>Express.js</li>
            <li>Stripe API (Payments, Connect, Payouts, Webhooks)</li>
            <li>MySQL & Sequelize</li>
            <li>Modular JavaScript SDK development</li>
            
          </ul>
        <br />
        <p className="text-gray-700  text-lg mb-6 space-y-2">
          By the end of this course, you'll be able to design and implement
          production-grade payment systems using the Stripe API. The course is
          centered around a service-based application model and includes
          essential workflows for Customers, Employees, and Admins.
        </p>
        </div>
      </section>
  )
}

export default CourseDetailsTop
